import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarPlus, CalendarX } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import AppointmentItem from "@/components/AppointmentItem";
import BookingModal from "@/components/BookingModal";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";

const todayStr = () => new Date().toISOString().slice(0, 10);
const CANCEL = [{ label: "İptal Et", status: "cancelled", testId: "member-appt-cancel" }];

export default function MemberAppointments() {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);

  const load = () => api.get("/appointments").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const onStatus = async (id, status) => {
    try { await api.put(`/appointments/${id}/status`, { status }); toast.success("Randevu iptal edildi"); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const upcoming = (items || []).filter((a) => a.status === "scheduled" && a.date >= todayStr());
  const past = (items || []).filter((a) => !(a.status === "scheduled" && a.date >= todayStr()));

  return (
    <div data-testid="member-appointments-page">
      <div className="flex items-center justify-between mb-4">
        <h1 className="font-display font-extrabold text-2xl text-white">Randevularım</h1>
        <Button onClick={() => setOpen(true)} data-testid="book-appointment-button" className="bg-[#FF5500] hover:bg-[#FF661A] text-white font-bold rounded-xl h-10"><CalendarPlus size={17} className="mr-1" /> Randevu Al</Button>
      </div>

      {items === null ? (
        <div className="space-y-2">{[...Array(3)].map((_, i) => <Skeleton key={i} className="h-16 rounded-2xl bg-[#13131C]" />)}</div>
      ) : (
        <div className="space-y-6">
          <section>
            <h3 className="text-xs font-bold uppercase tracking-widest text-[#68687B] mb-3">Yaklaşan</h3>
            {upcoming.length === 0 ? (
              <div className="flex flex-col items-center py-10 text-[#68687B] rounded-2xl border border-[#222230] bg-[#13131C]"><CalendarX size={32} className="mb-2 opacity-50" />Yaklaşan randevun yok.</div>
            ) : (
              <div className="space-y-2">{upcoming.map((a) => <AppointmentItem key={a.id} appt={a} showMember={false} actions={CANCEL} onStatus={onStatus} />)}</div>
            )}
          </section>
          {past.length > 0 && (
            <section>
              <h3 className="text-xs font-bold uppercase tracking-widest text-[#68687B] mb-3">Geçmiş</h3>
              <div className="space-y-2">{past.map((a) => <AppointmentItem key={a.id} appt={a} showMember={false} />)}</div>
            </section>
          )}
        </div>
      )}

      <BookingModal open={open} onOpenChange={setOpen} mode="member" onBooked={load} />
    </div>
  );
}
